import { useCallback, useState } from 'react';

const useAsync = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const execute = useCallback(async operation => {
    setIsLoading(true);
    setError(null);

    try {
      return await operation();
    } catch (operationError) {
      setError(operationError);
      throw operationError;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setIsLoading(false);
    setError(null);
  }, []);

  return { execute, isLoading, error, reset };
};

export default useAsync;
